import './publicPath';
import loadCustomFonts from './loadCustomFonts';
import React from 'react';
import * as ReactDOM from 'react-dom/client';
// import logger from './services/logger';
// import { logLevels, logEvents } from './constants/appConstants';

import RootApp from './RootApp';

loadCustomFonts();

/**
 * OPTIMIZATION: Pre-fetch translation files early
 * This starts the network request for translations before React renders,
 * reducing Time to Interactive by parallelizing the translation load
 */
function preFetchTranslations() {
    try {
    // Get language from URL pathname
        const pathParts = window.location.pathname.split('/');
        const possibleLang = pathParts[1];
        const lang =
      possibleLang && possibleLang.length >= 2 && possibleLang.length <= 5
          ? possibleLang
          : 'en';

        // Get CDN base and caching hash (these are set during build)
        const config = typeof _CONFIG_ !== 'undefined' ? _CONFIG_ : {};
        const cdnBase = config.cdn || '';
        const CACHING_HASH = process.env.CACHING_HASH || 'default_hash';

        // Build the translation file URL
        const translationUrl = `${cdnBase}lang/${CACHING_HASH}-${lang}.json`;

        // Pre-fetch the translation file
        // Use 'link' rel="prefetch" for best browser support
        if (typeof fetch === 'function') {
            // Silently fetch to warm up the connection/cache
            // Don't await - let it load in parallel with React
            fetch(translationUrl, {
                method: 'GET',
                cache: 'default',
                credentials: 'same-origin',
            }).catch(() => {
                // Silently fail - i18n will retry if needed
            });
        }

        // Also add a prefetch link to HTML head for extra browser optimization
        if (document && document.head) {
            const link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = translationUrl;
            link.as = 'fetch';
            document.head.appendChild(link);
        }
    } catch (err) {
        // Silently fail - this is just an optimization, not critical
        // eslint-disable-next-line no-console
        console.debug(
            'Translation pre-fetch failed (non-critical):',
            err.message,
        );
    }
}

// Start pre-fetching translations immediately, before React renders
preFetchTranslations();

async function renderApplication() {
    const rootElement = document.getElementById('root');
    if (!rootElement) throw new Error('Root element not found');

    const root = ReactDOM.createRoot(rootElement);
    root.render(<RootApp />);
}

Promise.resolve().then(renderApplication);
